import React from "react";

function BlogSchema({ blogData }) {

  const imageUrl = blogData.blog_image
    ? `https://www.ashnavaswani.com/csadmin/public/img/uploads/blogs/${blogData.blog_image}`
    : "";

  const blog = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": blogData.blog_name || "",
    "image": imageUrl,
    "description": blogData.blog_meta_desc || "",
    "articleBody": blogData.blog_desc
      ? blogData.blog_desc.replace(/<\/?[^>]+(>|$)/g, "")
      : "",
    "author": {
      "@type": "Person",
      "name": "Admin"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Ashna Vaswani",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.ashnavaswani.com/csadmin/public/img/uploads/settings/1692708180.png"
      }
    },
    "datePublished": blogData.created_at || "",
    "dateModified": blogData.updated_at || blogData.created_at || "",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": window.location.href
    }
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(blog)}
    </script>
  );
}

export default BlogSchema;
